import {Project} from "../api/Project";

export const arrowTransProject: Project = {
    id: 3,
    title: "ArrowTrans - A HTTP Server for your phone",
    description: "Converts your android phone/tablet into a HTTP Server. Use this HTTP Server to transfer your files, photos, videos and many more to anywhere without plugging your android phone to PC.",
    link: "https://play.google.com/store/apps/details?id=com.chiragji.arrowTrans",
    // image: "resources/icons/arrowTrans.svg",
    image: "https://play-lh.googleusercontent.com/nXJIVo5kSgBkh3bxc35LQibOkOQZzs_msky8f-VMGGSdZJ_em3ZMVjjfXu7Q-83M_Ms=w480-h960-rw",
    startDate: "August 2018",
    completeDate: "September 2018",
    technologies: {
        frontend: [
            "HTML 5",
            "CSS",
            "Angular.js"
        ],
        backend: [
            "Android",
            "Servlets",
            "SQLite",
            "Jetty"
        ]
    },
    hidden: false,
}